<template>
  <div>
    <list
      row-key="SchoolSettingId"
      ref="list"
      unit="激活名额库存明细"
      :page="true"
      :query-params="params"
      :show-checkbox="$permission.canEdit()"
      @reset="$refs.treeSelect.clearHandle()"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="归属机构">
          <tree-select
            ref="treeSelect"
            :props="props"
            :options="TreeData"
            :value="params.SchoolId"
            :clearable="true"
            :accordion="true"
            :parentSelect="true"
            placeholder="请选择"
            @node-select="onTreeSelect($event)"
          />
        </el-form-item>
        <el-form-item label="项目">
          <el-select v-model="params.Item" clearable>
            <el-option value="实操" />
            <el-option value="模拟" />
            <el-option value="课堂" />
          </el-select>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="params.StockType" placeholder="请选择" clearable>
            <el-option :value="0" label="激活出库"/>
            <el-option :value="1" label="购买入库"/>
            <el-option :value="2" label="回收出库"/>
          </el-select>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker
            v-model.trim="params.AddStartTime"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            :clearable="false"
            style="width: 193px"
          ></el-date-picker>
          <span style="margin:0 10px;">-</span>
          <el-date-picker
            v-model.trim="params.AddEndTime"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            :clearable="false"
            style="width: 193px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="学员姓名">
          <el-input v-model="params.FullName" placeholder="请填写学员姓名" clearable></el-input>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column label="归属机构" prop="DpName" min-width="120" />
        <el-table-column prop="Item" label="项目" />
        <el-table-column label="类型" prop="StockType">
          <template slot-scope="{row}">
            <span v-if="row.StockType==0">激活出库</span>
            <span v-else-if="row.StockType==1">购买入库</span>
            <span v-else-if="row.StockType==2">回收出库</span>
          </template>
        </el-table-column>
        <el-table-column label="数量" prop="Quantity"/>
        <el-table-column label="学员姓名" prop="FullName"/>
        <el-table-column label="证件号码" prop="CertNo" min-width="145px" />
        <el-table-column label="时间" prop="AddTime"/>
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>

<script>
import list from "@/components/common/list";
import listMixin from "@/mixins/list";
import treeSelect from "@/components/common/treeSelect";

export default {
  mixins: [listMixin],
  components: {
    list,
    treeSelect
  },
  data() {
    return {
      api: require("@/api/op/activestockdts").default,
      dpApi: require("@/api/basic/dp").default,
      params: {
        DpIdChain: null,
        FullName: "",
        StockType: null,
        AddStartTime: "",
        AddEndTime: "",
      },
      TreeData: [],
      props: {
        value: "DpId",
        label: "DpName",
        children: "children",
      },
    };
  },
  beforeMount() {
    this.dpApi.getAuthList({ DpTypes: [2,3,4], Status: 3, NoReturnParent: true }).then((res) => {
      this.TreeData = this.$commonJs.toTreeData(res.Data, "DpId");
    });
  },
  methods: {
    export() {
      this.api.export(this.$commonJs.obj.removeNullKey(this.$refs.list.tempQueryParams));
    },
    onTreeSelect(t) {
      if (!t) {
        this.params.DpIdChain = null;
      } else {
        this.params.DpIdChain = t.IdChain;
      }
    },
  }
};
</script>

<style>
</style>
